<form class="m-h-12 m-v-8"
    [formGroup]="form" (ngSubmit)="onRechercher()">
    <h3>{{ 'sigt.integration.rechercheRde.form.transactionsAmendements.title' | translate }}</h3>
    <mat-form-field class="d-flex">
        <mat-label>{{ 'sigt.integration.rechercheRde.form.transactionsAmendements.numeroTransactionAmendement' |
            translate
            }}</mat-label>
        <input matInput
            formControlName="numeroTransactionAmendement"
            placeholder="{{ 'sigt.integration.rechercheRde.form.transactionsAmendements.numeroTransactionAmendementPlaceholder' | translate }}"
            (input)="respecterSyntax($event)" />
        <mat-hint>{{ 'sigt.integration.rechercheRde.form.transactionsAmendements.numeroTransactionAmendementHint' |
            translate }}</mat-hint>
    </mat-form-field>

    <mat-form-field class="d-flex">
        <mat-label>{{ 'sigt.integration.rechercheRde.form.transactionsAmendements.du' | translate }}</mat-label>
        <input matInput
            formControlName="dateDebut"
            [matDatepicker]="pickerDateDebut">
        <mat-hint>{{ 'sigt.global.general.dateHint' | translate }}</mat-hint>
        <mat-datepicker-toggle matIconSuffix
            [for]="pickerDateDebut"></mat-datepicker-toggle>
        <mat-datepicker #pickerDateDebut></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="d-flex">
        <mat-label>{{ 'sigt.integration.rechercheRde.form.transactionsAmendements.au' | translate }}</mat-label>
        <input matInput
            formControlName="dateFin"
            [matDatepicker]="pickerDateFin">
        <mat-hint>{{ 'sigt.global.general.dateHint' | translate }}</mat-hint>
        <mat-datepicker-toggle matIconSuffix
            [for]="pickerDateFin"></mat-datepicker-toggle>
        <mat-datepicker #pickerDateFin></mat-datepicker>
    </mat-form-field>
    <div class="boutons-en-grille">
        <button mat-raised-button
            type="button"
            class="clear-search-button"
            (click)="form.reset()">
            {{ 'sigt.global.boutons.reinitialiser' | translate }}
        </button>

        <button mat-raised-button
            type="submit"
            class="search-button"
            [disabled]="!form.valid|| buttonClicked"
            (click)="onRechercher()"
            color="primary">
            {{ 'sigt.global.boutons.rechercher' | translate }}
        </button>
    </div>
</form>